import React, { useState } from 'react';
import classNames from 'classnames';
import styles from './assets/seance-actions.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faMinus } from '@fortawesome/free-solid-svg-icons';
import AmountLogs from './AmountLogs';
interface Props {
    original: any;
    data: any;
    setData: any;
    amountValue: number;
    name: string;
    changeValue: (field: string, value: string | null) => void;
}

const SeanceActionsColumn: React.FunctionComponent<Props> = ({
    original,
    changeValue,
    data,
    setData,
    name,
    amountValue,
}) => {
    const idValue = data[`${original?.id}`];

    const [valueState, setValue] = useState<string>(idValue?.[`${name}`]);
    const [checkValue, setCheckValue] = useState<number>(+!!idValue?.checkValue);
    const [err, setErr] = useState<string>('');
    let total = 0;
    const logs: any = [];

    if (original.paymentInvoices) {
        original.paymentInvoices.forEach((itP: any) => {
            if (+itP.status === 1) {
                logs.push(itP);
                total += itP?.amount ? +itP?.amount : 0;
            }
        });
    }
    total += valueState ? +valueState : 0;
    const handleSave = () => {
        if (+original.invoiceTotal < +total || +valueState > +amountValue) {
            setCheckValue(0);
            setErr('Amount more then Invoice Total!');
        } else {
            changeValue('some', 'some');
            setData({
                ...data,
                [`${original?.id}`]: {
                    ...idValue,
                    checkValue: 1,
                    [name]: +valueState,
                },
            });
        }
    };

    const actionValue = data[`${original?.id}`]?.action;

    const title: any = original?.[`${name}`];
    const varButtons: any = {
        1: { save: 'bg-primary text-white', cancel: 'bg-danger text-white' },
        0: { cancel: '', save: '' },
    };
    return (
        <div className={classNames(styles.actions)}>
            {actionValue ? (
                <div>
                    <AmountLogs logs={logs} />

                    <div style={{ display: 'flex' }}>
                        <div>
                            <input
                                value={`${valueState}`}
                                onChange={(event: any) => {
                                    event.preventDefault();
                                    setCheckValue(0);
                                    setValue(`${event.target.value}`);
                                }}
                                type="number"
                            />

                            <div style={{ display: 'block' }}>totalValueState: {total}</div>
                            <small className={'text-danger'}>{err}</small>
                        </div>

                        <div>
                            <button
                                className={`mr-3 w-100 ${varButtons[checkValue].save}`}
                                type={'button'}
                                onClick={() => handleSave()}
                            >
                                <FontAwesomeIcon icon={faCheck} />
                            </button>

                            <button
                                className={`w-100 ${varButtons[checkValue].cancel}`}
                                type={'button'}
                                onClick={() => setValue(idValue?.[`${name}`])}
                            >
                                <FontAwesomeIcon icon={faMinus} />
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                <div>
                    <AmountLogs logs={logs} />
                    <div>{title}</div>
                </div>
            )}
        </div>
    );
};

export default SeanceActionsColumn;
